import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionExpiredComponent } from 'src/app/shared/components/sessionExpired/sessionExpired/session-expired.component';
import { ApiConstants } from '../constants/api.constants';
import { AccountManagerConstants } from '../constants/user-constants/account-manager.constants';
import { AdminConstants } from '../constants/user-constants/admin.constants';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { RequestResponse } from '../models/request-response.model';
import {
    AccountManagerTableColumns,
    AccountManagerTableWithclosedDateColumns,
    EmployeeManagenebtRequestsTableColumns
} from '../models/table-columns/account-manager-table-columns.model';
import { TuwaiqUtil } from '../TuwaiqUtil';
import { AuthService } from './auth.service';
@Injectable({
    providedIn: 'root'
})
export class AccountManagerService {
    newRequestsView = VIEW_TYPE.NEW_REQUESTS;
    returnedRequestsView = VIEW_TYPE.RETURNED_REQUESTS;
    requestsAssignedToMeView = VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS;
    requestsInProgressView = VIEW_TYPE.INPROGRESS_REQUESTS;
    completedRequestsView = VIEW_TYPE.COMPLETED_REQUESTS;
    employeeManagementRequestsView = VIEW_TYPE.EMPLOYEE_MANAGEMENT_REQUESTS;
    isExpiredSession: boolean = false;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        public dialog: MatDialog
    ) {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        if (viewType === this.requestsInProgressView) {
            return new AccountManagerTableColumns(response.id, response.service.name, response.createdAt, response.creator?.name);
        } else if (viewType === this.completedRequestsView) {
            return new AccountManagerTableWithclosedDateColumns(
                response.id,
                response.service.name,
                response.createdAt,
                response.creator?.name,
                response?.icClosedAt
            );
        } else if (viewType === this.employeeManagementRequestsView) {
            return new EmployeeManagenebtRequestsTableColumns(response.id, response.requestStatus, response.requestType, response.createdAt);
        } else {
            return undefined;
        }
    }

    getTableColumns(requestObjectName: string) {
        return AccountManagerConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = AccountManagerConstants[requestObjectName].tableColumn.map(c => c.columnDef);

        const tableWithSelection = AccountManagerConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return AccountManagerConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu() {
        const list = [
            AccountManagerConstants.INPROGRESS_REQUESTS,
            AccountManagerConstants.COMPLETED_REQUESTS,
            AccountManagerConstants.EMPLOYEE_MANAGEMENT_REQUESTS,
            AdminConstants.DASHBOARD
        ];
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
    addUpdateAdmisionUser(data) {
        const api = ApiConstants.ADD__UPDATE_ADMISION_USER;
        return this.http.post(api, data).pipe(
            map(response => {
                //since response is null,
                response = response === null ? 'success' : response;
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    addAdmisionUserForSuperAdmin(data, isQa: boolean = false) {
        let api = ApiConstants.ADD_ADMISION_USER_FOR_SUPER_ADMIN;

        if (isQa) {
            api += '?isQa=true';
        }

        return this.http.post(api, data).pipe(
            map(response => {
                //since response is null,
                response = response === null ? 'success' : response;
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    emailSearch(parameters?: HttpParams) {
        const api = ApiConstants.SEARCH_EMAILS_FOR_SUPER_ADMIN;
        return this.http.get(api, { params: parameters }).pipe(
            map(response => {
                TuwaiqUtil.convertObjectKeysToCamelCase(response);
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    enableAdmisionUser(userId, comment?) {
        const api = ApiConstants.ENABLE_ADMISION_USER.replace('{userId}', userId.toString());
        return this.http.post(api, comment).pipe(
            map(response => {
                //since response is null,
                response = response === null ? 'success' : response;
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    disableAdmisionUser(userId, comment?) {
        const api = ApiConstants.DISABLE_ADMISION_USER.replace('{userId}', userId.toString());
        return this.http.post(api, comment).pipe(
            map(response => {
                //since response is null,
                response = response === null ? 'success' : response;
                return response;
            }),
            catchError(this.errorHandler.bind(this))
        );
    }
    /** Error Handling method */
    errorHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors'][0]);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    //TEMP:
    errorListHandler(errorResponse: HttpErrorResponse) {
        if (errorResponse.status === 401) {
            // this.authService.logout()
            this.handleSessionExpired();
        } else if (errorResponse.error && errorResponse.error['errors']) {
            return throwError(() => errorResponse.error['errors']);
        }
        return throwError(() => 'An error occurred; please try again later.');
    }

    handleSessionExpired() {
        if (!this.isExpiredSession) {
            this.dialog.open(SessionExpiredComponent, {
                width: '412px',
                disableClose: true
            });
            this.isExpiredSession = true;
        }
    }
}
